import type { MultilingualNodeConfig, MultilingualProperties, NodeConfig } from "../../schemas/index.ts";
import { isMultilingualProperty, isNestingProperty } from "./filterFunctions.ts";

type Options =
  | {
      lang: string;
    }
  | {
      appliedLanguageCodes: ReadonlyArray<string>;
    };

const pickValueWithFallbacks = (value: MultilingualProperties, langs: ReadonlyArray<string>) => {
  const foundLang = langs.find((lang) => lang in value.__ml);
  if (!foundLang) {
    return ""; // not technically correct but good enough. otherwise it gets very complicated and we haven't hit this case yet.
  }
  return value.__ml[foundLang];
};

export const monolingualizeConfig = (config: MultilingualNodeConfig, options: Options): NodeConfig =>
  Object.fromEntries(
    Object.entries(config).map(([name, value]) => [
      name,
      isMultilingualProperty(value)
        ? "lang" in options
          ? value.__ml[options.lang]
          : pickValueWithFallbacks(value, options.appliedLanguageCodes)
        : isNestingProperty(value)
          ? monolingualizeConfig(value, options)
          : value,
    ]),
  );
